module.exports = __webpack_public_path__ + "components/rewards/dogtag/static/logo-be34e0eff540dab662ba193062b8b184.webp";